const ScheduledVisitsStyle = theme => ({
    wrapper: {
        display: "flex",
        flex: 1,
        flexDirection: "column",
        backgroundColor: " #FAFAFA",
    },
    scheduledVisitsHeader: {
        height: 97,
        minHeight:97,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderBottom: "1px solid #979797",
        fontSize: 34,
        fontWeight: "Bold",
        fontFamily: "Proxima Nova",
    },
    scheduledVisitsBody: {
        "overflow-y": "auto",
        display: "flex",
        padding: "23px 150px"
    },
    item: {}
});

export const PendingFilesStyleV2 = (theme) => ({
  ordersV1: {
    overflow: 'hidden',
    flex: 1,

    '& .page-header': {
      height: 56,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      position: 'relative',
      borderBottom: '1px solid var(--light-grey)',
      borderTop: '1px solid var(--light-grey)',
      padding: '0 24px',

      '& .page-heading': {
        margin: 0,
        padding: 0,
        fontSize: 24,
        fontFamily: 'Proxima Nova',
        fontWeight: 600
      },

      '& .page-keyword-search': {
        position: 'absolute',
        right: 24,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',

        '& .page-keyword-search-label': {
          marginRight: 8
        },

        '& .page-keyword-search-input': {
          border: '1.5px solid #000000',
          width: 180,
          height: 24
        }
      }
    },

    '& .page-content': {
      display: 'flex',
      flexDirection: 'column',
      padding: '0 24px',
      height: 'calc(100vh - 114px)',
      overflowY: 'auto',

      '& .page-content-empty': {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center'
      },

      '& .page-order-icon': {
        '& .page-order-content-paste-icon': {
          width: 14
        },
      },

      '& .page-order-notifications': {
        display: 'flex'
      },

      '& .page-patient-name': {
        fontWeight: 600
      }
    }
  }
});

export default ScheduledVisitsStyle;